import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterDateDiffHuman"
    ,pure: false
})
export class FilterDateDiffHuman implements PipeTransform {
    transform(valueFrom:string,formatFrom:string):string {
        if(!valueFrom){
            return "-";
        }
        if(!formatFrom){
            formatFrom = "yyyy-MM-dd HH:mm:ss";
        }

        let dateFrom;
        try{
            let chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            chkPattern = /^(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2})$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2})$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            chkPattern = /^(?<year>\d{4})(?<month>\d{2})(?<day>\d{2})[\sT]{1}(?<hour>\d{2})(?<minute>\d{2})(?<second>\d{2}).*$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            chkPattern = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})[\sT]{1}(?<hour>\d{2}):(?<minute>\d{2}):(?<second>\d{2}).*$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            chkPattern = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})$/;
            if(chkPattern.test(valueFrom)){
                dateFrom = this.getDate(valueFrom,chkPattern);
            }

            let secFrom:number = dateFrom.getTime() * 0.001;
            let secTo:number = Date.now() * 0.001;
            let secDiff = secTo - secFrom;
            let secDay = 60 * 60 * 24;
            let secHour = 60 * 60;
            let secMinute = 60;

            let diffDay = Math.floor(secDiff / secDay) || 0;
            if(diffDay === 1){
                return "어제";
            }else if(diffDay > 1 && diffDay <= 7){
                return `${diffDay} 일 전`;
            }else if(diffDay > 8){
                return valueFrom;
            }

            let diffHour = Math.floor(secDiff / secHour) || 0;
            if(diffHour > 0){
                return `${diffHour} 시간 전`;
            }

            let diffMin = Math.floor(secDiff / secMinute) || 0;
            if(diffMin >= 0){
                return `${diffMin} 분 전`;
            }
        }catch(ex){
            console.error("FilterDateDiffHuman",ex);
        }
    }

    getDate(valueFrom:string,chkPattern:any):Date{
        let matched = chkPattern.exec(valueFrom);
        // console.log("FilterDateTime",matched,valueFrom);

        if(matched && matched.length > 0 && matched.groups){
            let matchedItem = matched.groups;
            let tmpDate = new Date();
            try{
                if(matchedItem.year && matchedItem.month && matchedItem.day){
                    tmpDate.setFullYear(Number(matchedItem.year),Number(matchedItem.month)-1,Number(matchedItem.day));
                }
            }catch(ex){
                console.error("FilterDateTime",ex);
            }
            try{
                if(matchedItem.hour && matchedItem.minute && matchedItem.second){
                    tmpDate.setHours(Number(matchedItem.hour),Number(matchedItem.minute),Number(matchedItem.second));
                }
            }catch(ex){
                console.error("FilterDateTime",ex);
            }
            // console.log("FilterDateTime",tmpDate.toISOString(),valueFrom);
            return tmpDate;
        }else{
            return null;
        }
    }
}
